import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from 'views/components';
import {Translate, translate} from 'views/module';

import backend from 'utils/backend';

const STRINGS = 'career.jobDetail.Invitations.Share';

const errorMessage = (error) => {
  return translate(`${STRINGS}.Errors.${['INV_001', 'INV_019'].includes(error.code) ? error.code : 'Default'}`);
};

// Sharing is final, so staff confirm it first.
const InvitationShareDialog = (props) => {
  const {invitationId, caregiverName, onClose, onShared} = props;
  const progressWrap = props.statusProgressWrap;

  const [saving, setSaving] = React.useState(false);

  const share = async () => {
    setSaving(true);
    await progressWrap(async () => {
      try {
        await backend.loom.invitation.shareWithFamily(invitationId);
      } finally {
        // A failed share can mean the invitation changed, so the list reloads either way.
        onShared();
      }
    }, {
      onErrorMessage: errorMessage,
      debugString: 'LOOM_INVITATION_SHARE',
    });
    setSaving(false);
  };

  return (
    <Dialog onClose={saving ? undefined : onClose}>
      <DialogTitle onClose={saving ? undefined : onClose}>
        <Translate expression={`${STRINGS}.Title`} />
      </DialogTitle>
      <DialogContent>
        <Typography variant='body2' pt={1}>
          <Translate
            expression={`${STRINGS}.Confirm`}
            substitute={{name: caregiverName || ''}}
          />
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' disabled={saving} onClick={onClose}>
          <Translate expression={`${STRINGS}.Keep`} />
        </Button>
        <Button disabled={saving} onClick={share}>
          <Translate expression={`${STRINGS}.Button`} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

InvitationShareDialog.propTypes = {
  invitationId: PropTypes.string.isRequired,
  caregiverName: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onShared: PropTypes.func.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(InvitationShareDialog));
